export default __webpack_public_path__ + "static/font-0dba095ff1ef921af2907a57988274ec.woff";